import { createBrowserHistory } from "history";

const trailingSlash = /(.+)\/$/.exec(window.location.pathname);

if (trailingSlash) {
    window.history.replaceState(undefined, undefined as any, trailingSlash[1] + window.location.search);
}

export const browserHistory = createBrowserHistory({ basename: "" });
